<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ editing ? 'Sửa' : 'Xem chi tiết' }} cây phân loại tài sản</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Mã cây phân loại tài sản:"
                                              label-for="codeAssetTypeTree"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              :label-class="editing? 'required' : ''">
                                    <b-form-input type="text" id="codeAssetTypeTree"
                                                  v-if="editing"
                                                  class="col-md-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.assetTypeTree.code.$model"
                                                  :state="($v.assetTypeTree.code.$dirty? !$v.assetTypeTree.code.$error : null) && ($v.codeUnique.$dirty? !$v.codeUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback" v-if="$v.assetTypeTree.code.$error">
                                        Vui lòng nhập mã
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback id="existingCodeFeedback" v-if="!$v.assetTypeTree.code.$error && ($v.codeUnique.$error)">
                                        Mã cây phân loại đã tồn tại
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ assetTypeTree.code }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Tên cây phân loại tài sản:"
                                              label-for="name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              :label-class="editing? 'required' : ''">
                                    <b-form-input type="text" id="name"
                                                  v-if="editing"
                                                  class="col-md-6"
                                                  aria-describedby="nameAssetTypeTreeFeedback"
                                                  v-model="$v.assetTypeTree.name.$model"
                                                  :state="$v.assetTypeTree.name.$dirty? !$v.assetTypeTree.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameAssetTypeTreeFeedback">
                                        Vui lòng nhập tên cây phân loại tài sản
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ assetTypeTree.name }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Chế độ quản lý tài sản cây phân loại:"
                                              label-for="name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="nameAssetTypeTreeFeedback"
                                                  class="col-md-6"
                                                  v-if="editing"
                                                  aria-describedby="nameAssetTypeTreeFeedback"
                                                  v-model="assetTypeTree.assetStandard">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ assetTypeTree.assetStandard }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Ngày hiệu lực từ ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align-md="left">
                                    <date-picker v-if="editing" v-model="assetTypeTree.startDate" placeholder="dd/mm/yyyy" class="col-md-6 no-padding"></date-picker>
                                    <label class="col-form-label" v-if="!editing">{{ assetTypeTree.startDate | formatDate }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Ngày hiệu lực đến ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align-md="left">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="parentIdFeedback"
                                                  v-model="$v.checkEndDate.$model"
                                                  :state="$v.checkEndDate.$dirty ? !$v.checkEndDate.$error : null"></b-form-input>
                                    <date-picker v-if="editing"
                                                 v-model="assetTypeTree.endDate"
                                                 :state="$v.checkEndDate.$dirty ? !$v.checkEndDate.$error : null"
                                                 placeholder="dd/mm/yyyy" class="col-md-6 no-padding">
                                    </date-picker>
                                    <b-form-invalid-feedback>
                                        Ngày kết thúc không được nhỏ hơn ngày bắt đầu
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">
                                        {{ assetTypeTree.endDate | formatDate }}
                                    </label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Kỳ kế toán năm tài sản:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align-md="left">
                                    <b-form-input type="text" v-if="editing"
                                                  class="col-md-6"
                                                  v-model="assetTypeTree.accountingPeriod">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">
                                        {{ assetTypeTree.accountingPeriod }}
                                    </label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Còn hiệu lực:"
                                              id="status"
                                              label-for="isActive"
                                              :label-cols="4"
                                              label-align-md="left"
                                              :horizontal="true">
                                    <b-form-checkbox id="isActive"
                                                     :disabled="!editing"
                                                     class="col-6"
                                                     v-model="assetTypeTree.isActive">
                                        <!--Trạng thái-->
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="" :label-cols="4">
                                    <!--<b-button type="button" variant="primary" @click="edit" v-show="!editing && authorize(['ManageAssetTypeTree'])">Sửa</b-button>-->
                                    <b-button type="submit" variant="primary" v-if="editing && authorize(['ManageAssetTypeTree'])"> Lưu</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel" v-if="editing && !$route.meta.editing"> Quay lại</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: '../' }"> Quay lại</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'AssetTypeTreeDetail',
        mixins: [validationMixin, mixins],
        data() {
            return {
                codeUnique: 'ok',
                assetTypeTree: {},
                editing: this.$route.meta.editing,
                checkEndDate: 'ok'
            }
        },
        computed: {
            assetTypeTreeId() {
                return this.$route.params.assetTypeTreeId;
            },
        },
        validations: {
            assetTypeTree: {
                code: { required },
                name: { required },
                description: {}
            },
            codeUnique: { required },
            checkEndDate: { required }
        },
        created() {
            this.loadAssetTypeTreeDetail();
        },
        methods: {
            loadAssetTypeTreeDetail() {
                var vm = this;
                return this.$services.get(`master-data/asset-type-trees/${this.assetTypeTreeId}`).done(assetTypeTree => {
                    vm.assetTypeTree = assetTypeTree;
                    vm.$store.dispatch('loadAssetTypeTrees');
                });
            },
            edit() {
                this.editing = true;
            },
            back() {
                this.$router.push({ path: '../' });
            },
            cancel() {
                var vm = this;
                this.loadAssetTypeTreeDetail().done(() => vm.editing = false);
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (this.assetTypeTree.startDate && (new Date(this.assetTypeTree.startDate) > new Date(this.assetTypeTree.endDate))) {
                    vm.checkEndDate = "";
                }
                else {
                    vm.checkEndDate = "ok";
                }
                if (vm.assetTypeTree.code != '' && vm.assetTypeTree.code != null) {
                    vm.$services.get(`master-data/existing-asset-type-tree-code`, { id: vm.assetTypeTree.id || '', code: vm.assetTypeTree.code || '' }).done(returnData => {
                        if (!returnData) {
                            vm.codeUnique = "required";
                            if (!vm.$v.$invalid) {
                                vm.$services.put(`master-data/asset-type-trees/${vm.assetTypeTreeId}`, vm.assetTypeTree).done(() => {
                                    vm.$toastr.s('Cập nhật cây phân loại tài sản thành công');
                                    vm.back();
                                    vm.$store.dispatch('loadAssetTypeTrees');
                                });
                            }
                        }
                        else {
                            vm.codeUnique = "";
                        }
                    });
                }
            },
        }
    }
</script>
<style scoped>
</style>
